/**
 * <collector-card> — crossfades from the "master" to the "showcase" image.
 * Desktop uses CSS :hover. Touch devices don't have a reliable persistent
 * hover state, so tapping the media area toggles the same "is-active" class
 * that the hover CSS uses.
 */
class CollectorCard extends HTMLElement {
  connectedCallback() {
    const media = this.querySelector('.collector-card__media');
    if (!media) return;

    media.addEventListener('click', () => {
      this.classList.toggle('is-active');
    });
  }
}

if (!customElements.get('collector-card')) {
  customElements.define('collector-card', CollectorCard);
}
